import { render } from "./AssignTask.vue?vue&type=template&id=01d68ecf&scoped=true"
import script from "./AssignTask.vue?vue&type=script&lang=js"
export * from "./AssignTask.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d68ecf"]])

export default __exports__